import { Suspense, lazy } from 'react';
import { useLocation } from 'react-router-dom';
import Loader from '../Shared/Loader';

const Navigation = lazy(() => import('./Navigation'));
const TopBar = lazy(() => import('./Topbar'));
const AdminTopBar = lazy(() => import('./AdminTopBar'));

const NAV_PATHS = new Set([
  '/mod/uploadcsv',
  '/mod/reportez',
  '/mod/csvupload',
  '/mod/comparador',
  '/mod/bitacora',
  '/mod/reportec',
]);
const ADMIN_PATHS = new Set(['/admin/sitios', '/admin/genlla', '/admin/usuarios']);

export default function Layout({ children }) {
  const { pathname } = useLocation();
  const Header = NAV_PATHS.has(pathname)
    ? Navigation
    : ADMIN_PATHS.has(pathname)
    ? AdminTopBar
    : TopBar;

  return (
    <Suspense fallback={<Loader />}>
      <div id="my-page">
        <Header />
        <div className="main-container bg-img">{children}</div>
      </div>
    </Suspense>
  );
}
